var map = {
	"./arrow.svg": 6153,
	"./badge.svg": 6647,
	"./boluo.svg": 5278,
	"./boluoCen.svg": 1985,
	"./boluoColor.svg": 5838,
	"./boluoGrey.svg": 9932,
	"./boluoIcon.svg": 9934,
	"./circleBg.svg": 6659,
	"./close.svg": 7886,
	"./down.svg": 2762,
	"./downloadAndroid.svg": 8599,
	"./finish.svg": 8347,
	"./fourLeaf.svg": 3558,
	"./list.svg": 2030,
	"./lock.svg": 9035,
	"./logo.svg": 5715,
	"./next.svg": 5481,
	"./noData.svg": 2543,
	"./out.svg": 9142,
	"./pause-bg.svg": 1800,
	"./pause.svg": 5872,
	"./phonorecord.svg": 3559,
	"./pineapple.svg": 312,
	"./play-bg.svg": 9744,
	"./play.svg": 2408,
	"./playSmall.svg": 4365,
	"./previous.svg": 3273,
	"./right.svg": 8732,
	"./star.svg": 8674,
	"./time.svg": 4525,
	"./timeLine.svg": 5495,
	"./tinyBuoluo.svg": 7202,
	"./triangle.svg": 2466,
	"./wx.svg": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;